import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, setAnalyticsUser } from '@/lib/analytics';
import { useAuthStore } from '@/store/useAuthStore';

/**
 * Suit la navigation SPA dans Google Analytics.
 *
 * GA4 envoie déjà automatiquement le premier `page_view` au chargement, donc on
 * ignore le tout premier rendu ici pour éviter un double comptage, puis on
 * envoie un `page_view` à chaque changement de route. Associe aussi l'ID de
 * l'utilisateur connecté aux événements.
 */
export function AnalyticsTracker() {
  const location = useLocation();
  const user = useAuthStore((s) => s.user);
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  useEffect(() => {
    setAnalyticsUser(user?.id ?? null);
  }, [user?.id]);

  return null;
}
